var jipOpen = false;
var openJipId = '';

if (document.layers) document.captureEvents(Event.CLICK);
if (document.layers || document.all) document.onmouseclick = CaptureClick;
if (document.addEventListener) document.addEventListener('click', CaptureClick, true);

function CaptureClick(eventObject) {
	if(eventObject.button == 0 && jipOpen){
		closeJip();
	}
}

function closeJip() {
	ShowHide('div', 'jip-' + openJipId);
	jipOpen = false;
	return false;
}

function openJip(id) {
	ShowHide('div', 'jip-' + id);
	jipOpen = true;
	openJipId = id;
	return false;
}